export const UtilConstant = {
    SET_UI_BUSY : 'SET_UI_BUSY',
    SET_UI_IDLE : 'SET_UI_IDLE',
 }